import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
    AppNotificationService,
    AppNotificationType,
    ArrayModel,
    ConfigConstants,
    CSE_STOCK,
    CseStockService,
    LoadingScreenComponent,
    MaterialModel,
    MaterialStockModel,
    ModalClass,
    NotificationModel,
    SYNC_STATUS,
    SynchronizationService,
} from '@evorait/pace-core';
import ConfirmationMaterialStockModel from '../../confirmation/confirmation-material-consume/confirmation-material-stock/confirmation-material-stock.model';
import { ConfirmationMaterialStockComponent } from '../../confirmation/confirmation-material-consume/confirmation-material-stock/confirmation-material-stock.component';

@Injectable({
    providedIn: 'root',
})
export class MaterialStockService {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly translate: TranslateService,
        private readonly appNotificationService: AppNotificationService,
        private readonly modalService: BsModalService,
        private readonly synchronizationService: SynchronizationService,
        private readonly cseStockService: CseStockService,
    ) {}

    public triggerBootStock(
        notification: NotificationModel | undefined,
        listMaterial: ArrayModel<MaterialModel>,
        loadingScreenInstance?: BsModalRef<LoadingScreenComponent>,
    ): Observable<void | undefined> {
        return of(undefined).pipe(
            mergeMap(() => this.synchronizationService.receiveBootStock()),
            catchError((error) => {
                this.log.debug(`MaterialStockService: openBootStock: receiveBootstock failed with error `, error);
                return of(undefined);
            }),
            mergeMap(() => this.cseStockService.updateBootStock()),
            map((materialStock: MaterialStockModel) => {
                const bootStockMaterialList = this.cseStockService.createCseStockMaterialModels(
                    materialStock,
                    notification,
                    listMaterial,
                    CSE_STOCK.BOOT_STOCK,
                );
                return bootStockMaterialList;
            }),
            map((material) => {
                if (loadingScreenInstance) {
                    loadingScreenInstance.hide();
                }
                this.modalService.show(ConfirmationMaterialStockComponent, {
                    backdrop: 'static',
                    class: ModalClass.MODAL_MEDIUM,
                    initialState: {
                        isBootStock: true,
                        syncStatus: SYNC_STATUS.SYNC_SUCCESS,
                        model: new ConfirmationMaterialStockModel(
                            listMaterial,
                            notification,
                            ConfigConstants.BOOT_STOCK_SCREEN,
                            material,
                        ),
                    },
                    ariaLabelledBy: 'confirmation-material-stock-modal-title',
                });
            }),
            catchError((error) => {
                this.log.error(`MaterialStockService : openBootStockUI: Error `, error);
                this.appNotificationService.setAppNotification(
                    AppNotificationType.ERROR,
                    <string>this.translate.instant('MATERIAL_REQUEST_ERROR_TITLE'),
                    <string>this.translate.instant('MATERIAL_REQUEST_ERROR_BODY'),
                );

                return of(undefined);
            }),
        );
    }

    public triggerOtherStock(notification: NotificationModel, listMaterial: ArrayModel<MaterialModel>): void {
        this.modalService.show(ConfirmationMaterialStockComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            initialState: {
                isBootStock: false,
                model: new ConfirmationMaterialStockModel(
                    listMaterial,
                    notification,
                    ConfigConstants.OTHER_STOCK_SCREEN,
                ),
            },
            ariaLabelledBy: 'confirmation-material-stock-modal-title',
        });
    }
}
